import { API_LOCATION } from '@/config/config';
import axios from 'axios';

export const userService = {
  login,
  logout,
};

function login(email, pass) {
  const _params = {
    email: email,
    pass: pass
  };

  return axios.post(API_LOCATION + '/rpc/login', _params, {
    headers: {
      Prefer: 'return=representation',
    }
  }).then(response => {
    if (response) {
      const user = response.data[0];
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('user', JSON.stringify(user));
      // console.log(user.token);
      return user;
    }
  });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
  localStorage.removeItem('isAdmin');
}
